import { JetView } from 'webix-jet';
import { devConfig, countries, profile, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterFlujoCajaResumidoView.
 * Extends JetView to create a filter view for cash flow summary.
 */
export default class FilterFlujoCajaResumidoView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'datepicker', // Date picker for selecting a month
                            name: 'Date',
                            id: 'Date',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: new Date(), // Default value is the current date
                            format: '%M %Y',
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            on: {
                                onChange: function (data, obj) {
                                    // Event handler for change
                                    var currentValue = this.getValue();
                                    if (screen.width > 600) {
                                        if (currentValue.length > 0) {
                                            $$('consultDesk').enable(); // Enable button if value is selected
                                        } else {
                                            $$('consultDesk').disable(); // Disable button if no value
                                        }
                                    } else {
                                        if (currentValue.length > 0) {
                                            $$('consultDesk2').enable(); // Enable button for mobile
                                        } else {
                                            $$('consultDesk2').disable(); // Disable button for mobile
                                        }
                                    }
                                },
                            },
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Hide based on configuration
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Read-only dropdown for selected country
                            name: 'CountrySelect2',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() || // Hide based on configuration
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'combo', // Dropdown for selecting a betting shop
                            name: 'BetShopId',
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'),
                            hidden: !devConfig.getPermAction('filterByBetShop', 'Add'),
                            css: 'prm-filterByBetShop',
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'BetShopId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed for dynamic loading
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger on input length
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text', // Input for user ID
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'radio', // Radio button for including canceled bets
                            name: 'WithCanceledBets',
                            id: 'WithCanceledBets',
                            label: _('Con apuestas anuladas?'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Si') },
                                { id: 1, value: _('No') },
                            ],
                        },
                        {
                            view: 'radio', // Radio button for including pending awards
                            name: 'WithPendingAwards',
                            id: 'WithPendingAwards',
                            label: _('Con premios pendientes?'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Si') },
                                { id: 1, value: _('No') },
                            ],
                        },
                        {
                            view: 'radio', // Radio button for selecting report type
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Detallado') },
                                { id: 1, value: _('Totales') },
                            ],
                        },
                        {
                            view: 'radio', // Radio button for including payment gateways
                            name: 'WithPaymentGateways',
                            id: 'WithPaymentGateways',
                            label: _('Con pasarelas de pago?'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Si') },
                                { id: 1, value: _('No') },
                            ],
                        },
                    ],
                },
            ],
        };
        const left3 = {
            margin: 5,
            id: 'a3',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a3',
                    cols: [
                        {
                            view: 'text', // Input for agent ID
                            name: 'UserIdAgent',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('ID Concesionario'),
                            hidden: !devConfig.getPermAction('filterByAgent', 'Add'),
                            css: 'prm-filterByAgent',
                        },
                        {
                            view: 'text', // Input for sub-agent ID
                            name: 'UserIdAgent2',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Subconcesionario'),
                            hidden: !devConfig.getPermAction('filterByAgent2', 'Add'),
                            css: 'prm-filterByAgent2',
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };
        const left4 = {
            margin: 5,
            id: 'b2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'text', // Input for creation date of betting shop
                            name: 'DateCreatedBetShop',
                            id: 'DateCreatedBetShop',
                            css: 'reportrange3',
                            label:
                                "<span class='webix_icon icon-calendar'></span>" +
                                _('Fecha de creación punto de venta'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            on: {
                                onFocus: function (o, e, v) {
                                    // Date range picker on focus
                                    $('.reportrange3 input').daterangepicker({
                                        ranges: {
                                            Today: [moment(), moment()],
                                            Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                            'Last Month': [
                                                moment().subtract(1, 'month').startOf('month'),
                                                moment().subtract(1, 'month').endOf('month'),
                                            ],
                                        },
                                        locale: {
                                            format: 'YYYY-MM-DD', // Date format
                                        },
                                    });
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Date picker for creation date of betting shop
                            name: 'DateCreatedBetShop2',
                            id: 'DateCreatedBetShop2',
                            stringResult: true,
                            minWidth: 200,
                            label:
                                "<span class='webix_icon icon-calendar'></span>" +
                                _('Fecha de creación punto de venta'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default value is today's date
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                        { id: 'grav3', gravity: 3 }, // Gravity for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // First section of filters
                },
                {
                    margin: 10,
                    cols: [left2], // Second section of filters
                },
                {
                    margin: 10,
                    cols: [left3], // Third section of filters
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left4], // Fourth section of filters
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for advanced filters
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Content of advanced filters
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear filters
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                    },
                },
                {
                    view: 'button', // Button to submit filters
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('flujoCajaResumido:filter', [
                            filterdata, // Trigger filter event
                        ]);
                        $$('b5').collapse(); // Collapse accordion
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear filters in second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                    },
                },
                {
                    view: 'button', // Button to submit filters in second form
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    id: 'consultDesk2',
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('flujoCajaResumido:filter', [
                            filterdata, // Trigger filter event
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for main filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for main filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Content of main filters
                                    devConfig.getPartnerSelected() == '8'
                                        ? accordion_section // Show advanced filters if condition met
                                        : { height: 1 },
                                    buttons, // Buttons for main filters
                                ],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Content of filters
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title of the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Content of the form
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section for larger screens
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide(); // Hide element for small screens
                $$('grav3').hide(); // Hide element for small screens
            }
            if (profile.typeDate !== 2) {
                $$('DateCreatedBetShop2').hide(); // Hide date picker based on profile settings
                $$('DateCreatedBetShop').show(); // Show alternative date picker
            } else {
                if (true) {
                    $$('DateCreatedBetShop2').show(); // Show second date picker
                    $$('DateCreatedBetShop').hide(); // Hide first date picker
                }
            }
            if (devConfig.getCountryReport()) {
                if (screen.width > 600) {
                    $$('consultDesk').enable(); // Enable button for larger screens
                } else {
                    $$('consultDesk2').enable(); // Enable button for smaller screens
                }
            }
        });
    }
}

// FILE DOCUMENTED
